import { DatePipe, JsonPipe, NgFor, NgIf } from '@angular/common';
import { Component, inject, Inject, DestroyRef, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import {
  IAmanoOne_AccessGroup,
  IAmanoOne_AccessGroupApiResponse,
  IAmanoOneAccessGroups,
  IAmanoOneAccessgroupUpdateResponse,
  IAmanoOneAccessHolderUpdateResponse,
  IAmanoOneLotConfigurationSettings,
  IAmanoOne_AccessGroupsWithMembershipResponse,
  IAmanoOneCredentialTypeResponse,
  IAmanoOneCredentialSystemCodeResponse,
} from 'src/app/shared/code/interfaces/parcs-interfaces';
import { MatListModule, MatListOption } from '@angular/material/list';
import { ParcsDataService } from 'src/app/core/services/data/parcs-data.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { firstValueFrom } from 'rxjs';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { IAmanoOneAddExistingParkerRequest } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-dialog-amano-parcs-add-new-accessholder',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule,
    MatListModule,
    DatePipe,
    NgIf,
    NgFor,
  ],
  templateUrl: './dialog-amano-parcs-add-new-accessholder.component.html',
  styleUrl: './dialog-amano-parcs-add-new-accessholder.component.scss',
})
export class DialogAmanoParcsAddNewAccessholderComponent implements OnInit {
  accessHolderGroups: IAmanoOneAccessGroups[] = [];
  accessGroupUpdateInProgress: boolean = false;
  selectedSourceAccessGroup: string = '';
  cardNumberConflictExists: boolean = false;
  accessGroupLists: IAmanoOne_AccessGroupsWithMembershipResponse = {} as IAmanoOne_AccessGroupsWithMembershipResponse;
  accessHolder: IAmanoOneAccessHolderUpdateResponse = {} as IAmanoOneAccessHolderUpdateResponse;
  credentialTypeSettingValue: string = '';
  credentialCodeSettingValue: string = '';
  credentialCodeDisabled: boolean = true;
  credentialTypesList: IAmanoOneCredentialTypeResponse[] = [];
  credentialCodesList: IAmanoOneCredentialSystemCodeResponse[] = [];
  credentialTypeId: string = '';
  credentialTypeNoSystemCodeFlag: boolean = false;
  parkerCardNumber: string = '';
  createAmanoOneProfile: boolean = false;
  submitButtonDisabled: boolean = true;
  newAmanoOneAddExistingParkerRequest: IAmanoOneAddExistingParkerRequest = {} as IAmanoOneAddExistingParkerRequest;

  //Services
  #_parcsDataService = inject(ParcsDataService);
  #_destroyRefService = inject(DestroyRef);
  #_dialogService = inject(MessageDialogService);
  _appGeneralStateService = inject(AppGeneralStateService);

  constructor(
    public _dialogRef: MatDialogRef<DialogAmanoParcsAddNewAccessholderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.accessHolder != null) {
      this.cardNumberConflictExists = true;
      this.accessHolder = data.accessHolder;
    } else {
      this.cardNumberConflictExists = false;
    }
  }

  async ngOnInit(): Promise<void> {
    this.parkerCardNumber = this.data.cardNumber;
    this.getCredentialTypeList(this._appGeneralStateService.currentLotNumber).then((res) => {
      this.credentialTypesList = res;
    });
    this.accessHolderGroups = await this.getAllAmanoOneAccessHolderGroups(this.data.facilityId);
    this.createAmanoOneProfile = this.data.cardNumber != null && this.data.cardNumber != '';
    //this.selectedSourceAccessGroup = '9dcc7955-5c0e-46fa-88f8-691c83190e82';
  }

  // getAccessControlGroupLists(parkerId: string, lotNumber: string, facilityId: string): void {
  //   var accessGroups: IAmanoOneAccessgroupUpdateResponse[];
  //   this.#_parcsDataService
  //     .getAmanoOneParcsAccessGroupsLists(parkerId, lotNumber, facilityId)
  //     .pipe(takeUntilDestroyed(this.#_destroyRefService))
  //     .subscribe({
  //       next: (res) => {
  //         this.accessGroupLists = res;
  //       },
  //       error: (err: any) => {
  //         this.accessGroupUpdateInProgress = false;
  //         this.#_dialogService.snackBarTopCenterTimed(
  //           'An error has occurred and the Access Holder Membership lists could not be found. Please close spACE AR and try again.',
  //           4000,
  //         );
  //       },
  //       complete: () => {
  //         this.accessHolderGroups = this.accessGroupLists.availableGroups;
  //       },
  //     });
  // }

  onEvaluateSubmittButtonDisabled(): void {
    this.submitButtonDisabled = !this.evaluateCreateAmanoDataReadyToSave(); // || this.selectedSourceAccessGroup != '';
  }

  async getAllAmanoOneAccessHolderGroups(facilityId: string): Promise<IAmanoOneAccessGroups[]> {
    let accessHolderGroups: IAmanoOneAccessGroups[];
    let status: boolean = true;

    try {
      accessHolderGroups = await firstValueFrom(
        this.#_parcsDataService.getAmanoOneParcsAccessGroupsByFacilityId(facilityId),
      );
    } catch (err) {
      status = false;
    }
    return accessHolderGroups;
  }

  onOverwriteParkerAccessGroup(): void {
    this._dialogRef.close();
  }

  evaluateCreateAmanoDataReadyToSave(): boolean {
    // Set ready to save = true, and then fail any of the checks below
    let isReadyToSave: boolean = true;
    this.submitButtonDisabled = false;
    try {
      // is Access Group Selected?
      if (
        this.selectedSourceAccessGroup == '' ||
        this.selectedSourceAccessGroup == null ||
        this.selectedSourceAccessGroup == undefined
      ) {
        throw new Error('Access Group not selected');
      } else {
        this.newAmanoOneAddExistingParkerRequest.accessGroupId = this.selectedSourceAccessGroup;
      }

      // If the card number is blank, then thes crednetialType and credentialSystemCode are not enabled
      if (this.parkerCardNumber != '' && this.parkerCardNumber != null && this.parkerCardNumber != undefined) {
        // is Credential Type Selected?
        if (this.credentialTypeId == '' || this.credentialTypeId == null || this.credentialTypeId == undefined) {
          throw new Error('Credential Type not selected');
        } else {
          this.newAmanoOneAddExistingParkerRequest.credentialType = this.credentialTypeId;
        }

        // if Credential Type requires System Code, is System Code selected?
        if (this.credentialTypeId == '7') {
          //requuires system code
          if (
            this.credentialCodeSettingValue == '' ||
            this.credentialCodeSettingValue == null ||
            this.credentialCodeSettingValue == undefined
          ) {
            throw new Error('Credential System Code not selected');
          } else {
            this.newAmanoOneAddExistingParkerRequest.credentialCode = this.credentialCodeSettingValue;
          }
        } else {
          this.newAmanoOneAddExistingParkerRequest.credentialCode = '';
        }
      } else {
        this.submitButtonDisabled = true;
      }
      // Based on above, enable or disable parcs data save ability
    } catch (err) {
      console.error('Error: Amano One Data not ready to save:', err.message);
      this.submitButtonDisabled = true;
      isReadyToSave = false;
    }
    return isReadyToSave;
  }

  onCredentialTypeChange(event: any): void {
    this.evaluateCreateAmanoDataReadyToSave();
    // If no credential type is selected, clear all related fields and broadcasts
    if (this.credentialTypeId == '') {
      this.credentialCodesList = [];
      this.credentialCodeSettingValue = '';
      return;
    }

    // Check if the selected Credential Type has No System Code flag set
    // True indicates that this credential type does not use a system code
    const noSystemCodeFlag: boolean = this.credentialTypesList.find(
      (type) => type.credentialTypeId === +this.credentialTypeId,
    ).noSystemCode;
    this.credentialTypeNoSystemCodeFlag = noSystemCodeFlag;
    this.credentialCodeSettingValue = '';

    // If No System Code is selected, clear the system code list and disable the dropdown
    // Broadcast credential type and null/empty system code to add parker parent component
    if (noSystemCodeFlag) {
      this.credentialCodesList = [];
      this.credentialCodeDisabled = true;
    } else {
      // If System Code is required, get the system code list for the selected credential type

      // Get the list of system codes
      if (this.credentialTypeId != undefined && this.credentialTypeId != null && this.credentialTypeId != '') {
        this.getCredentialSystemCodeList(this._appGeneralStateService.currentLotNumber, +this.credentialTypeId).then(
          (res) => {
            this.credentialCodesList = res;
          },
        );
        this.credentialCodeSettingValue = '';
      } else {
        this.credentialCodesList = [];
        this.credentialCodeSettingValue = '';
      }
    }
  }

  onCredentialCodeChange(event: any): void {
    this.evaluateCreateAmanoDataReadyToSave();
    if (
      this.credentialCodeSettingValue != undefined &&
      this.credentialCodeSettingValue != null &&
      this.credentialCodeSettingValue != ''
    ) {
    } else {
      this.credentialCodeSettingValue = '';
    }
  }

  // Gets the list of Credential Types from Amano One PARCS system.
  async getCredentialTypeList(lotNumber: string): Promise<IAmanoOneCredentialTypeResponse[]> {
    let credentialTypes: IAmanoOneCredentialTypeResponse[] = [];
    try {
      credentialTypes = await firstValueFrom(this.#_parcsDataService.AmanoOne_CredentialType_GetList(lotNumber));
    } catch (err) {
      credentialTypes = [];
    }
    return credentialTypes;
  }

  // Gets the list of Credential System Codes from Amano One PARCS system.
  async getCredentialSystemCodeList(
    lotNumber: string,
    credentialTypeId: number,
  ): Promise<IAmanoOneCredentialSystemCodeResponse[]> {
    let credentialSystemCodes: IAmanoOneCredentialSystemCodeResponse[] = [];

    try {
      credentialSystemCodes = await firstValueFrom(
        this.#_parcsDataService.AmanoOne_CredentialSystemCode_GetList(lotNumber, credentialTypeId),
      );
    } catch (err) {
      credentialSystemCodes = [];
    }
    return credentialSystemCodes;
  }
}
